import React, { useContext } from 'react';
import Modal from "react-bootstrap/Modal";
import { adsContext } from '../../UseContext/AdsContext';


const AdFinalPreviewPopup = () => {

  const { 
    showAdFinalPreviewPopup, setShowAdFinalPreviewPopup,
    // createAd, 
  } = useContext(adsContext);

  return (
    <>
      <Modal show={showAdFinalPreviewPopup} onHide={() => setShowAdFinalPreviewPopup(false)} centered backdrop="static" keyboard={false} className="create-call" >
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <section>
            <h1 className='mb-0'>Final Preview Popup</h1>
          </section>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AdFinalPreviewPopup;
